import { all } from "redux-saga/effects";
// import authSaga from "~/store/sagas/authentication-saga";
// import basketSaga from "./sagas/basket-saga";
// import passwordSaga from "./sagas/password-saga";
// import profileDetailsSaga from "./sagas/profile-details-saga";
// import profileMembershipSaga from "./sagas/profile-membership-saga";
// import signupSaga from "./sagas/signup-saga";
// import checkoutSaga from "./sagas/checkout-saga";
import searchSaga from "./sagas/search-saga";
import bookOfTheMonthSaga from "./sagas/book-of-the-month-saga";
// import voucherSaga from "./sagas/voucher-saga";
import returnCodeSaga from "~/store/sagas/return-code-saga";
// import bonusPointsSaga from "./sagas/bonus-points-saga";
// import orderDetailsSaga from "./sagas/order-details-saga";
import authorSaga from "./sagas/author-saga";
// import upgradeMembershipSaga from "./sagas/upgrade-membership-saga";
// import notificationsSaga from "./sagas/notifications-saga";

export default function* rootSaga() {
    yield all([
        // authSaga(),
        authorSaga(),
        // basketSaga(),
        // bonusPointsSaga(),
        bookOfTheMonthSaga(),
        // checkoutSaga(),
        // notificationsSaga(),
        // orderDetailsSaga(),
        // passwordSaga(),
        // profileDetailsSaga(),
        // profileMembershipSaga(),
        returnCodeSaga(),
        searchSaga()
        // signupSaga(),
        // upgradeMembershipSaga(),
        // voucherSaga()
    ]);
}
